import { gql } from "@apollo/client";

export const CREATE_CLIENT_MUTATION = gql`
  mutation CreateClient($clientData: ClientInput!) {
    createClient(clientData: $clientData) {
      client {
        id
        name
        surname
        clientId
      }
    }
  }
`;
